/**
 * Created by 58 on 2016/11/2.
 */
/*require('./../style/person-search.less');*/
var Component = require('./Component'),
    $ = require('jQuery'),
    template = require('../template/person-search.html'),
    dispatcher = require('./../global/dispatcher'),
    ActionType = require('./../constant/ActionType'),
    Scrollbar = require('./Scrollbar'),
    html2Text = require('../utils/html2Text');

var PersonSearch = function (options) {
    this._open = false;
    (function (self) {
        var defaults = {
            template: template,
            search: function (keyword, cb) {
                cb([]);
            }
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    // scrollbar
    (function (self) {
        var scrollbar = new Scrollbar({
            window: self._element.find(".im-personsearch-content"),
            content: self._element.find(".im-personsearch-person")
        });
        self._children['scrollbar'] = scrollbar;
        self._element.find(".im-personsearch-content").append(scrollbar.getElement());
    })(this);
    /*
     * 点击查询结果
     * */
    (function (self) {
        self.getElement().on("click", ".im-personsearch-item", function (e) {
            e.preventDefault();
            self.selectedItem($(this));
        });
    })(this);
};

PersonSearch.prototype = Object.create(Component.prototype);

/*
 * 显示搜索结果，加载scrollbar
 * */
PersonSearch.prototype.open = function () {
    Component.prototype.show.call(this);
    var scrollbar = this._children['scrollbar'];
    scrollbar.init();
    scrollbar.calHeight();
    this._open = true;
};

PersonSearch.prototype.close = function () {
    Component.prototype.hide.call(this);
    this._open = false;
};

/*
 * 插入联系人，展示搜索框
 * */
PersonSearch.prototype.insertPerson = function (data) {
    if (!data.length) {
        return false
    }
    var person = '<li class="im-personsearch-person-title">联系人</li>',
        i,
        ulList = this.getElement().find(".im-personsearch-person");
    for (i in data) {
        person += '<li class="im-personsearch-item" data-userid="' + data[i].id + '" data-source="' + data[i].source + '" data-index="' + i + '"><div class="im-personsearch-item-wrap">';
        person += '<img src="' + data[i].avatar + '" class="im-personsearch-item-avatar">';
        person += '<p class="im-personsearch-item-name">' + html2Text(data[i].name) + '</p></div></li>';
    }
    ulList.html(person);
    this.open();
    if (i == 0) {
        this.getElement().find(".im-personsearch-item").eq(0).addClass("im-item-hover");
    }
    this._data.index = i;
};

/*
 * 选择查询结果
 * */
PersonSearch.prototype.selectedItem = function ($ele) {
    var user_id = $ele.attr("data-userid"),
        source = $ele.attr("data-source");
    dispatcher.dispatch({
        type: ActionType.PERSON_CHECK,
        data: {
            user_id: user_id,
            user_source: source
        }
    });
    this.close();
    this.triggerEvent("personCheck");
};

/*
 * 按键操作
 * */
PersonSearch.prototype.keyOperation = function (keycode, val) {
    var self = this,
        focusItem,
        focusItemHeight,
        index = this._data.index,
        contentWrap = this.getElement().find(".im-personsearch-content"),
        scrollbar = this._children['scrollbar'],
        scrollHeight;
    switch (keycode) {
        case 38:   // UP
            focusItem = this.getElement().find(".im-item-hover");
            focusItemHeight = focusItem.height();
            if (focusItem.length) {
                focusItem.removeClass("im-item-hover");
                if (focusItem.attr("data-index") !== "0") {
                    focusItem.prev().addClass("im-item-hover");
                    scrollHeight = focusItem.prev().offset().top - contentWrap.offset().top;
                    if (scrollHeight < 0) {
                        scrollbar.scroll(scrollHeight);
                    } else if (scrollHeight > 0 && scrollHeight < 6 * focusItemHeight) {

                    } else if (scrollHeight > 6 * focusItemHeight) {
                        scrollbar.scroll(scrollHeight);
                    }
                } else {
                    this.getElement().find(".im-personsearch-item").eq(index).addClass("im-item-hover");
                    scrollbar.scrollToBottom();
                }
            } else {
                this.getElement().find(".im-personsearch-item").eq(index).addClass("im-item-hover");
                scrollbar.scrollToBottom();
            }
            break;
        case 40:    // down
            focusItem = this.getElement().find(".im-item-hover");
            focusItemHeight = focusItem.height();
            if (focusItem.length) {
                focusItem.removeClass("im-item-hover");
                if (focusItem.attr("data-index") == index) {
                    this.getElement().find(".im-personsearch-item").eq(0).addClass("im-item-hover");
                    scrollbar.scroll(0);
                } else {
                    focusItem.next().addClass("im-item-hover");
                    scrollHeight = focusItem.next().offset().top - contentWrap.offset().top;
                    if (scrollHeight < 0) {
                        scrollbar.scroll(scrollHeight);
                    } else if (scrollHeight < 6 * focusItemHeight) {

                    } else if (scrollHeight >= 6 * focusItemHeight) {
                        scrollbar.scroll(scrollHeight - 5 * focusItemHeight);
                    }
                }
            } else {
                this.getElement().find(".im-personsearch-item").eq(0).addClass("im-item-hover");
                scrollbar.scroll(0);
            }
            break;
        case 13:
            focusItem = this.getElement().find(".im-item-hover");
            if (focusItem.length) {
                this.selectedItem(focusItem);
            }
            break;
        default:
            if (val == "") {
                this.close()
            }
            this._options.search(val, function (data) {
                self.insertPerson(data);
            });
    }
};

module.exports = PersonSearch;
